// extracted by mini-css-extract-plugin
export default {"logo":"logo__mANer","image":"image__Ys80Q"};